import MatchEvent from 'interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';

function getConnectedEventFactory(matchEventTypeIds: MatchEventType[]) {
  return function (matchEvents: MatchEvent[], matchEvent: MatchEvent) {
    return matchEvents.find((evt) => {
      return (
        matchEventTypeIds.includes(evt.matchEventTypeId) &&
        (evt.sorting === matchEvent.sorting ||
          (evt.internal?.sorting && evt.internal?.sorting === matchEvent.internal?.sorting) ||
          (evt.internal?.sorting && !evt.id && matchEvent.id && evt.internal?.sorting === matchEvent.sorting))
      );
    });
  };
}

export const getConnectedAssistEvent = getConnectedEventFactory([
  MatchEventType.ASSIST,
  MatchEventType.INDIRECT_ASSIST,
]);

export const getConnectedFouledEvent = getConnectedEventFactory([MatchEventType.FOULED]);

export const getConnectedOffenceEvent = getConnectedEventFactory([MatchEventType.OFFENCE]);

export const getConnectedPlayerOnEvent = getConnectedEventFactory([MatchEventType.PLAYER_ON]);

export const getConnectedPenaltySaveEvent = getConnectedEventFactory([MatchEventType.PENALTY_SAVE]);

export const getConnectedPenaltyMissEvent = getConnectedEventFactory([MatchEventType.PENALTY_MISS]);
export const getConnectedPenaltiesMissEvent = getConnectedEventFactory([MatchEventType.PENALTIES_MISS]);

export const getConnectedPenaltyGoalEvent = getConnectedEventFactory([MatchEventType.PENALTY_GOAL]);
export const getConnectedPenaltiesGoalEvent = getConnectedEventFactory([MatchEventType.PENALTIES_GOAL]);
